import getFieldValue from '../elements/getFieldValue';
import { t } from './i18n';

/**
 * Replaces any %interpolation_phrases% with their real value from the form, either
 * from the form fields or from i18n phrases.
 */
export default function replaceInterpolationTags(form, str) {
  return str.replace(/%([^%\s]+)%/g, (_match, key) => getFieldValue(form, key) || t(form, key));
}
